import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../../components-v2/Theme/theme';

export const donationStyles = StyleSheet.create({
	popup: {
		maxWidth: `calc(100vw - ${SPACE[32]}px)`,
		width: 460,
	},
	dateRow: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	dateInput: {
		flex: 1,
		minWidth: 0,
	},
});
